import Channel from '@/shared/classes/channels/channel'
import { useAppStore, useTVStore } from '@/shared/store'
import { useAnalytics } from '@/app/context/AnalyticsContext/AnalyticsContext'
import { tvAssetType } from '@/shared/constants/appConstants'
import { ChannelProps } from '@/types/tv/channels/Channel'

const useChannelChangeHook = () => {
    const {
        setWhatNextId,
        isPIPMode,
        setSelectedChannel,
        setDisplayNextButton,
        displayNextButton,
        setIsTVPlaying,
    } = useTVStore()

    const { setAssetType } = useAppStore()
    const Analytics = useAnalytics()

    const logChannelChangeToAnalytics = (channel: Channel) => {
        const currentDate: Date = new Date()
        const polishDate: string = currentDate.toLocaleString('pl-PL', {
            timeZone: 'Europe/Warsaw',
            hour12: false,
        })
        Analytics?.analyticsLogEvent('tune to a channel', {
            channel_name: channel.name,
            channel_id: channel.id,
            timestamp: polishDate,
        })
    }

    const handleChannelChange = (channel: Channel) => {
        if (isPIPMode && document.pictureInPictureElement)
            document.exitPictureInPicture()

        const { id } = channel
        if (id) setWhatNextId(id)
        logChannelChangeToAnalytics(channel)
        setAssetType(tvAssetType)
        setSelectedChannel(channel as ChannelProps)
        setIsTVPlaying(true)
        if (displayNextButton) setDisplayNextButton(false)
    }
    return { handleChannelChange }
}

export default useChannelChangeHook
